<ng-container>
  <router-outlet></router-outlet>
</ng-container>
